import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  ActivityIndicator
} from 'react-native'
import React, { useState, useEffect, useMemo } from 'react'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import Card from '../../../components/shared/card/Card'
import { fontPalette, globalStyles } from '../../../static/styles/global'
import CustomButton from '../../../components/shared/button/Button'

import CardSeparator from '../../../components/shared/card/CardSeparator'
import SelectKeyValue from '../../../components/shared/form/SelectKeyValue'
import { usePersonalStore } from '../../../stores/personalInfo'
import { convertTo12HourTime, getLocalTimeWithTimezoneOffset, mapSelectKey } from '../../../utils'
import { useLabourStore } from '../../../stores/labour'
import moment from 'moment'
import { useHomeStore } from '../../../stores/home'
import { useclockstore } from '../../../stores/clock'
// import { Toast, useToast } from 'react-native-toast-notifications'
import { delayHttpRequest } from '../../../helpers/globalHelper'
import AsyncStorage from '@react-native-async-storage/async-storage'
import Toast from 'react-native-toast-message'
import { getCurrentLocationAndCheckQuadrilateral } from '../../../helpers/geoFencingHelper'
import { useTranslation } from 'react-i18next'
import { Loading } from '../../../components/shared/navigator/Loading'

const Clockin = ({ route, navigation }) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    relationships,
    isClockIn,
    setClockIn,
    shiftid
  } = params

  const [selectedstore, setSelectedStore] = useState('')
  const [selectedDepartment, setSelectedDepartment] = useState<any>(null)
  const [disabled, setDisabled] = useState(true)
  const clockstore = useclockstore()
  const homestore = useHomeStore()
  const personalstore = usePersonalStore()
  const labourStore = useLabourStore()
  const [loader, setLoader] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const { loading, error, personalData, fetchData, updateData } =
    usePersonalStore()

  const [currentTime, setCurrentTime] = useState(new Date())
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => clearInterval(interval)
  }, [])


  useEffect(() => {
    clockstore.fetchdepartments(
      personalstore?.personalData?.entityId,
      homestore?.homeData?.laborSaverStoreID,
      labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0
    )
  }, [])

  useEffect(() => {
    const selectedDepartmentDetails = clockstore?.departmentsData?.data?.find((item) => item.department_Focus == homestore?.homeData?.deptId);
    setSelectedDepartment(selectedDepartmentDetails)
  }, [clockstore?.departmentsData?.data, homestore?.homeData?.deptId])


  const formattedTime = currentTime.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })

  const shiftdetails = useMemo(() => {
    return labourStore.scheduleData?.shiftInfo?.find((item: any) => item.shiftID == shiftid)
  }, [labourStore.scheduleData, shiftid])


  const data = {
    EssUserOnboardingKey: userId,
    entityId: personalData.entityId,
    corporationId: personalData.corpEntityId,
    storeId: homestore.homeData.storeNumber,
    employeeId: labourStore.labourData.employeeNumber,
    shiftId: shiftdetails?.shiftID,
    userId: labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0,
    departmentId: homestore.homeData.deptId,
    inType: 'IN',
    attendanceDate: new Date(),
    // clockPunchTime: getLocalTimeWithTimezoneOffset()
    clockPunchTime: new Date().toISOString()
  }

  // useEffect(() => {
  //   if (clockstore.postData?.successStatus !== undefined) {
  //     if (clockstore.postData.successStatus) {
  //       setClockIn(true)
  //       AsyncStorage.setItem('clockin', JSON.stringify(true))
  //       navigation.navigate('LabourScreen')
  //       shiftaccepted(true)
  //     } else {
  //       shiftaccepted(false)
  //     }
  //   }
  // }, [clockstore.postData])

  const handleSubmit = async () => {
    // const flag =
    //   !homestore.homeData?.geofencingStatus &&
    //   homestore.homeData?.coordinateOneLatitude != null

    // if (flag) {
    //   const topLeft = [
    //     homestore.homeData.coordinateOneLatitude,
    //     homestore.homeData.coordinateOneLongitude
    //   ]
    //   const topRight = [
    //     homestore.homeData.coordinateTwoLatitude,
    //     homestore.homeData.coordinateTwoLongitude
    //   ]
    //   const bottomRight = [
    //     homestore.homeData.coordinateThreeLatitude,
    //     homestore.homeData.coordinateThreeLongitude
    //   ]
    //   const bottomLeft = [
    //     homestore.homeData.coordinateFourLatitude,
    //     homestore.homeData.coordinateFourLongitude
    //   ]

    //   try {
    //     setLoader(true)
    //     const empLocation = null
    //     const res = await getCurrentLocationAndCheckQuadrilateral(
    //       topLeft,
    //       topRight,
    //       bottomLeft,
    //       bottomRight,
    //       empLocation
    //     )

    //     if (res) {
    //       await clockstore.postclockin(data)
    //       console.log('Location is inside')
    //       setClockIn(true);
    //       navigation.navigate('LabourScreen')
    //     } else {
    //       Toast.show({
    //         type: 'error',
    //         position: 'bottom',
    //         text1: t('Cannot submit Clock In from outside the store'),
    //         visibilityTime: 5000,
    //         autoHide: true,
    //         topOffset: 60
    //       })
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     setLoader(false)
    //   }
    // }
    //  else {
    try {
      await clockstore.postclockin(data)
      setClockIn(true);
      navigation.navigate('LabourScreen')
    }
    catch (error) {

    }

  }
  const shiftaccepted = (successStatus) => {
    if (successStatus === false) {
      Toast.show({
        type: 'error',
        text1: t(clockstore.postData.error),
        position: 'bottom'
      })
    } else {
      Toast.show({
        type: 'success',
        text1: t('Your are successfully clocked-in'),
        position: 'bottom'
      })
    }
  }
  const { t } = useTranslation()

  if (clockstore?.loading) return <Loading />
  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={[globalStyles.vCenterItems]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter
            ]}
          >
            {t('clockin')}
          </Text>
          <TouchableOpacity
            style={{
              marginTop: 20,
              borderRadius: 5,
              backgroundColor: '#4FC7E8',
              width: '90%'
            }}
            onPress={() => navigation.navigate('LabourScreen')}
          >
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                textAlign: 'center',
                padding: 10,
                fontFamily: fontPalette.primaryBold
              }}
            >
              {t('cancel')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          marginTop: -44,
          padding: 16,
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <Card>
          <>
            <Text style={{ fontSize: 30, fontFamily: fontPalette.primaryBold }}>
              {formattedTime}
            </Text>
            <CardSeparator />
            <Text
              style={[
                globalStyles.inputLabel,
                globalStyles.inputLabelLarge,
                globalStyles.inputLabelPrimary,

              ]}
            >
              {t('Scheduled Shift')}
            </Text>

            <Text style={{ fontSize: 18 ,fontFamily:fontPalette.primaryRegular}}>
              {moment(shiftdetails?.date).format('MMM D')},{' '}
              {convertTo12HourTime(shiftdetails?.time_In)} -{' '}
              {convertTo12HourTime(shiftdetails?.time_Out)}
            </Text>
            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('store')}
              </Text>

              <Text style={{ fontSize: 18 ,fontFamily:fontPalette.primaryRegular}}>
                {homestore.homeData.storeName}
              </Text>
            </View>

            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('Department')}
              </Text>

              <Text style={{ fontSize: 18 ,fontFamily:fontPalette.primaryRegular}}>
                {/* {homestore.homeData.deptName} */}
                {selectedDepartment?.depName}
              </Text>
            </View>
          </>
        </Card>

        {clockstore.loading ? (
          <ActivityIndicator size="large" />
        ) : (
          <TouchableOpacity
            style={[styles.custom2, { backgroundColor: '#9dd086' }]}
            onPress={() => handleSubmit()}
          >
            <View>
              <Text
                style={{ fontSize: 20, fontFamily: fontPalette.primaryBold, color: 'white' }}
              >
                {t('Submit Clock In')}
              </Text>
            </View>
          </TouchableOpacity>
        )}

      </View>
    </>
  )
}

export default Clockin

const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingLeft: 16,
    paddingRight: 16,
    height: 40,
    width: '90%',
    alignItems: 'center',
    backgroundColor: '#0088CF',
    color: 'black',
    borderWidth: 0,
    borderRadius: 11
  },
  custom2: {
    justifyContent: 'center',
    flexDirection: 'row',
    height: 40,
    width: '95%',
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 0,
    borderRadius: 10
  },
  customStore: {
    flexDirection: 'row',
    height: 39,
    width: '100%',
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 1,
    borderRadius: 10,
    borderColor: '#CCCC'
  }
})
